<script setup lang="ts">
import PatientNextVisitInstructionsFormDialog from "@/components/models/patient/forms/PatientNextVisitInstructionsForm.vue";
import { usePatient } from "@/composables/models/patient/usePatient";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import { computed } from "vue";
import { useRoute } from "vue-router";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.nextVisitInstruction" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__INSTRUCTIONFORNEXTVISIT);
    },
  },
});

const route = useRoute();
const patientId = computed(() => (route.params as { id: string }).id);

const { data: patient, isLoading: isPatientLoading } = usePatient({ id: patientId });
</script>

<template>
  <loading v-if="isPatientLoading" />
  <template v-else>
    <patient-next-visit-instructions-form-dialog
      v-if="patient"
      :patient="patient"
    />
    <span
      v-else
      class="tw:text-center tw:mt-5"
    >
      {{ $t("models.patient.shared.noPatient") }}
    </span>
  </template>
</template>

<style scoped></style>
